import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { ItemCatComponent } from '../item-cat/item-cat.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-item-cat-list',
  templateUrl: './item-cat-list.component.html',
  styleUrls: ['./item-cat-list.component.css']
})
export class ItemCatListComponent implements OnInit {

  public menu_item_id = '1';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['item_cat_name', 'item_cat_name_en', 'item_cat_type_name', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<ItemCatComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'item_cat', 'item_cat_name': '', 'item_cat_name_en': '', 'item_cat_type_name': '' };

  Success_Msg; Error_Msg; Del_Msg; Row; Purchases; Productions;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Row').subscribe((res: string) => {
      this.Row = res;
    });

    translate.get('Purchases').subscribe((res: string) => {
      this.Purchases = res;
    });

    translate.get('Productions').subscribe((res: string) => {
      this.Productions = res;
    });

  }


  ngOnInit() {
    //console.log(this.applicationConstants.user_info['authList']);
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    let condition = '';

    if (this.model['item_cat_name'] != undefined)
      condition = " AND (`item_cat_name` LIKE '%" + this.model['item_cat_name'] +
        "%' OR `item_cat_name_en` LIKE '%" + this.model['item_cat_name'] + "%')";

    let query = this.queryList.all_itemCat + condition;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          if (element.item_cat_type == 1)
            element.item_cat_type_name = this.Row;
          else if (element.item_cat_type == 2)
            element.item_cat_type_name = this.Purchases;
          else if (element.item_cat_type == 3)
            element.item_cat_type_name = this.Productions;
        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  openDialog(item_cat_id = null) {
    this.addDialogRef = this.dialog.open(ItemCatComponent, {
      hasBackdrop: false,
      data: (item_cat_id != null ? item_cat_id : null)
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
        // if (result != null && result['status'] == 'success')
        //   this.search();
        // if (item_cat_id != null)
        //   this.search();
      });
  }

  delete(item_cat_id) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'item_cat_id': item_cat_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
